<template>
  <div class="">
    <div class="sm:mx-auto sm:w-full sm:max-w-screen-md">
      <h2 class="mt-6 text-center text-2xl font-extrabold text-brand-gray-900">
        Log Into Your Account
      </h2>
      <p class="mt-2 text-center text-sm text-brand-gray-600">
        The email you provided is already associated with an account. Please login below.
      </p>
      <div v-if="hasError('status')" class="mt-4 bg-amber-50 border-l-4 border-amber-400 p-4">
        <div class="flex">
          <div class="flex-shrink-0">
            <!-- Heroicon name: solid/exclamation -->
            <svg class="h-5 w-5 text-amber-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
              <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd" />
            </svg>
          </div>
          <div class="ml-3">
            <p class="text-sm text-amber-700">
              {{errors.detail}}
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
      <div class="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
        <form class="mt-4 grid grid-cols-1 gap-y-6 sm:gap-x-8" action="#" method="POST" @submit.prevent="submit">
          <div>
            <div class="relative border border-brand-gray-300 rounded-md px-3 py-2 shadow-sm focus-within:ring-1 focus-within:ring-purple-600 focus-within:border-purple-600">
              <label for="emailAddress" class="absolute -top-2 left-2 -mt-px inline-block px-1 bg-white text-xs font-medium text-brand-gray-900">Email Address</label>
              <input type="email" v-model="form.emailAddress" id="emailAddress" class="block w-full border-0 p-0 text-brand-gray-900 placeholder-brand-gray-500 focus:ring-0 sm:text-sm" placeholder="student@hurstreview.com" required>
            </div>
            <p v-if="hasError('emailAddress')" class="mt-2 text-sm text-red-600">{{errors['emailAddress'][0]}}</p>
          </div>
          <div>
            <div class="relative border border-brand-gray-300 rounded-md px-3 py-2 shadow-sm focus-within:ring-1 focus-within:ring-purple-600 focus-within:border-purple-600">
              <label for="password" class="absolute -top-2 left-2 -mt-px inline-block px-1 bg-white text-xs font-medium text-brand-gray-900">Password</label>
              <input type="password" v-model="form.password" id="password" class="block w-full border-0 p-0 text-brand-gray-900 placeholder-brand-gray-500 focus:ring-0 sm:text-sm" required>
            </div>
            <p v-if="hasError('password')" class="mt-2 text-sm text-red-600">{{errors['password'][0]}}</p>
          </div>
          <div class="flex justify-center">
            <button type="submit"
                    :disabled="submitting"
                    class="w-full sm:w-1/2 flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-purple-600 hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500 disabled:bg-purple-300 disabled:cursor-wait">
                            <span class="flex" v-if="submitting">
                                <svg class="animate-spin h-5 w-5 mr-2" xmlns="http://www.w3.org/2000/svg" fill="none"
                                     viewBox="0 0 24 24">
                                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                <path class="opacity-75" fill="currentColor"
                                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                </svg> Logging In
                            </span>
              <span v-else>Login</span>
            </button>
          </div>
          <div class="flex justify-end">
            <a class="inline-block align-baseline  text-sm text-indigo-700 hover:text-blue-800" href="/forgot-password">
              Forgot Password?
            </a>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'Login',

  props: {user: Object},

  data() {
    return {
      errors: {},
      form: {
        emailAddress: this.user.emailAddress,
        password: null
      },
      submitting: false
    }
  },

  methods: {
    hasError(field) {
      return this.errors.hasOwnProperty(field);
    },

    async submit() {
      this.submitting = true;
      this.errors = {};
      try {
        const {data} = await axios.post('/login', {
          username: this.form.emailAddress,
          password: this.form.password,
        });
        localStorage.setItem('userId', data.userId);
        localStorage.setItem('sessionId', data.sessionId);
        this.$emit('login-complete');
      } catch ( { response }) {
        this.errors = response.data
      }
      this.submitting = false;
    }
  }
};
</script>

<style scoped>

</style>